import {
  Box,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { Plus } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { ProviderConsultantForm } from '../Consultants/ProviderConsultantForm';

export function ProviderConsultantFormModal(props: { providerId: number; onClose?: () => void }) {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Button size="sm" onClick={onOpen} leftIcon={<Icon as={Plus} />}>
        <Trans>Add User</Trans>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box ml="auto">
              <ProviderConsultantForm providerId={props.providerId} onClose={onClose} />
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
